export enum SnackbarStateEnum { Error, Success }